"use strict";

exports.__esModule = true;
exports.transparentize = exports.getColor = void 0;

var _tinycolor = require("@ctrl/tinycolor");

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getColor = (color, theme) => {
  return (0, _lodash.default)(theme, `colors.${color}`, color);
};

exports.getColor = getColor;

const transparentize = (color, opacity, theme) => {
  const raw = getColor(color, theme);
  return new _tinycolor.TinyColor(raw).setAlpha(opacity).toRgbString();
};

exports.transparentize = transparentize;